<template>
  <v-container class="fill-height">
    <v-row justify="center" align="center">
      <v-col cols="auto" md="6">
        <v-row justify="center">
          <v-col cols="12">
            <div class="display-3 font-weight-bold blue--text text-center">
              {{ $t("welcome-t1") }}
            </div>
          </v-col>
          <v-col cols="12">
            <h2 class="text-center">{{ $t("welcome-t2") }}</h2>
          </v-col>
          <v-col cols="12" v-if="false">
            <div class="subtitle-1 text-center">
              {{ $t("welcome-t3") }}
            </div>
          </v-col>
          <v-col cols="auto">
            <v-btn
              color="primary"
              block
              rounded
              @click="listarEmpresas()"
              :loading="loading"
              >{{ $t("welcome-btn1") }}</v-btn
            >
          </v-col>
          <v-col cols="auto" v-if="$store.state.usuario.rol == 'IT'">
            <v-tooltip color="primary" right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="primary" dark v-bind="attrs" v-on="on">
                  fa-solid fa-circle-exclamation
                </v-icon>
              </template>
              <span>Seleccionar otra empresa desde cualquier pantalla (ctrl + a)</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" v-if="false">
            <v-file-input
              v-model="fileExcel"
              label="Excel"
              outlined
              dense
              hide-details
              @change="pruebaCargaExcel"
            ></v-file-input>
          </v-col>
          <v-col cols="auto" v-if="false">
            <v-btn color="primary" block rounded @click="LoginV2()"
              >Login v2</v-btn
            >
          </v-col>
          <v-col cols="auto" v-if="false">
            <v-btn color="primary" block rounded @click="listar()"
              >Listar v2</v-btn
            >
          </v-col>
          <v-col cols="auto" v-if="false">
            <v-btn color="primary" block rounded @click="peticionSegura()"
              >Petición segura</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="auto" md="6">
        <v-img :src="require('@/assets/modelo_1.jpg')" width="500" />
      </v-col>
    </v-row>

    <v-dialog v-model="dialog_emp" width="700" persistent scrollable>
      <v-card>
        <v-toolbar color="light-blue" dark>
          <v-toolbar-title>{{ $t("welcome-dialog-t1") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog_emp = !dialog_emp">
            <v-icon size="30">fa-regular fa-circle-xmark</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-data-table
            :headers="headers"
            :items="items_emp"
            :items-per-page="-1"
            :search="search"
            dense
          >
            <template v-slot:top>
              <v-text-field
                v-model="search"
                outlined
                dense
                hide-details
                :label="$t('search')"
                class="ma-2"
              ></v-text-field>
            </template>
            <template v-slot:[`item.action_select`]="{ item }">
              <v-icon @click="selecEmp(item)">
                fa-regular fa-hand-pointer
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import decode from "jwt-decode";
import * as CryptoJS from "crypto-js";
var XLSX = require("xlsx");

export default {
  data: () => ({
    search: "",
    dialog_emp: false,
    items_emp: [],
    emp_selected: "",
    loading: false,
    selectedItem: 0,
    key: "",
    iv: "",
    fileExcel: null,
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t("welcome-dialog-table-header-t1"),
          value: "nombre_empresa",
        },
        {
          text: this.$t("welcome-dialog-table-header-t2"),
          value: "action_select",
          align: "center",
        },
      ];
    },
  },
  created() {
    //console.log(this.$store.state.usuario)
    if (!this.$store.state.emp) {
      this.listarEmpresas();
    } else {
      if (!localStorage.getItem("cod_emp")) {
        this.listarEmpresas();
      }
    }
  },
  methods: {
    pruebaCargaExcel() {
      const file = Array.isArray(this.fileExcel)
        ? this.fileExcel[0]
        : this.fileExcel;

      if (!file) return;

      const reader = new FileReader();

      reader.onload = (e) => {
        const bstr = e.target.result;
        const workbook = XLSX.read(bstr, { type: "binary" }); // Parse the binary data

        const wsname = workbook.SheetNames[0];
        const ws = workbook.Sheets[wsname];

        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        console.log(data);
      };

      reader.readAsBinaryString(file);
    },
    listarEmpresas() {
      this.loading = true;
      axios
        .get(
          "api/UsuariosXEmpresas/ListarSinLogo/" +
            this.$store.state.usuario.idUsuario
        )
        .then((response) => {
          //console.log(response.data);
          if (response.data.length == 1 && !localStorage.getItem("cod_emp")) {
            this.selecEmp(response.data[0]);
            this.loading = false;
            return;
          }
          this.dialog_emp = true;
          this.loading = false;
          this.items_emp = response.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    selecEmp(item) {
      this.dialog_emp = false;
      axios
        .put("api/Usuarios/ActualizarEmpSeleccionada", {
          id_usuario: this.$store.state.usuario.idUsuario,
          emp_seleccionada: item.id_empresa,
        })
        .then(() => {
          localStorage.setItem("cod_emp", item.id_empresa);
          this.$store.dispatch("guardarEmpresa", item);
        });
    },
    LoginV2() {
      axios
        .post("api/Usuarios/LoginV2", {
          email: "john.linares@devco.sv",
          password: "devco_JL@22",
          nit: "0614-120121-108-0",
        })
        .then((response) => {
          console.log(response.data.token);

          var token = response.data.token;
          var decode_token = decode(token);

          this.decryptUsingAES256(decode_token.c1);
        });
    },
    listar() {
      var header = {
        Authorization: "Bearer " + this.$store.state.token,
        FacturaE_API_NIT: "0614-120121-108-",
        "Content-Type": "application/json",
      };
      var configuracion = { headers: header };

      axios
        .get("api/Usuarios/ListarV2", configuracion)
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    decryptUsingAES256(decString) {
      this.key = CryptoJS.enc.Utf8.parse("4512631236589784");
      this.iv = CryptoJS.enc.Utf8.parse("4512631236589784");

      var decrypted = CryptoJS.AES.decrypt(decString, this.key, {
        keySize: 128 / 8,
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return decrypted.toString(CryptoJS.enc.Utf8);
    },
    peticionSegura() {
      axios.get("api/Usuarios/Listar").then((response) => {
        console.log(response.data);
        var jsonObj = JSON.parse(this.decryptUsingAES256(response.data));
        console.log(jsonObj);
      });
    },
  },
};
</script>